import {makeAutoObservable, reaction} from 'mobx';

import type {CollectionStore} from '../../../api/utils/collectionStore';
import type {Destructible, WithReactionDispose} from '../../../utils/store';

import {type PaymentApiModel, paymentStore} from '../../../api/payment';
import {ReactionDisposeManager} from '../../../utils/store';

type Config = {
  paymentsStore: CollectionStore<PaymentApiModel>;
};

export class PaymentHistoryStore implements Destructible, WithReactionDispose {
  readonly disposer = new ReactionDisposeManager();
  private readonly paymentsStore: CollectionStore<PaymentApiModel>;

  constructor({paymentsStore}: Config) {
    this.paymentsStore = paymentsStore;

    makeAutoObservable(this, undefined, {
      autoBind: true,
    });

    this.setupReactions();

    this.paymentsStore.fetch();
  }

  destruct() {
    this.disposer.dispose();
  }

  get isFetching(): boolean {
    return this.paymentsStore.isFetching;
  }

  get payments(): PaymentApiModel[] {
    return this.paymentsStore.items;
  }

  async loadNextPage(): Promise<void> {
    if (this.paymentsStore.isFetching) {
      return;
    }

    if (this.paymentsStore.cursor.next) {
      await this.paymentsStore.fetch(
        {
          cursor: this.paymentsStore.cursor.next,
        },
        {
          appendTo: 'end',
          silent: true,
        },
      );
    }
  }

  private setupReactions() {
    this.disposer.watch(
      'payment_update',
      reaction(
        () => paymentStore.updating,
        updating => {
          if (updating.success && updating.entity) {
            this.paymentsStore.updateItem(updating.entity, updating.entity);
          }
        },
      ),
    );
  }
}
